import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '@clean-code/hooks/usePermissions';
import { PermissionScreen } from '@clean-code/types/permissions';

type PermissionRouteProps = {
  children: React.ReactNode;
  screen: PermissionScreen;
};

export function PermissionRoute({ children, screen }: PermissionRouteProps) {
  const { canOpen, isLoading } = usePermissions();

  // Deciding before permissions load would bounce allowed users to /realtime.
  if (isLoading) {
    return null;
  }

  if (!canOpen(screen)) {
    return <Navigate to="/realtime" />;
  }

  return <>{children}</>;
}
